import { render, staticRenderFns } from "./AmenityDetails.vue?vue&type=template&id=b4ebf45a&scoped=true"
import script from "./AmenityDetails.vue?vue&type=script&lang=js"
export * from "./AmenityDetails.vue?vue&type=script&lang=js"
import style0 from "./AmenityDetails.vue?vue&type=style&index=0&id=b4ebf45a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ebf45a",
  null
  
)

export default component.exports